import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Archive = function Archive(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M4 7.9966c-.164-.0042-.2831-.0137-.3902-.035a2 2 0 0 1-1.5714-1.5714C2 6.197 2 5.9647 2 5.5s0-.697.0384-.8902a2 2 0 0 1 1.5714-1.5714C3.803 3 4.0353 3 4.5 3h15c.4647 0 .697 0 .8902.0384a2 2 0 0 1 1.5714 1.5714C22 4.803 22 5.0353 22 5.5s0 .697-.0384.8902a2 2 0 0 1-1.5714 1.5714c-.1071.0213-.2262.0308-.3902.035M10 13h4M4 8h16v8.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C17.7202 21 16.8802 21 15.2 21H8.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 18.7202 4 17.8802 4 16.2z"
    })
  }));
};
export default Archive;